import { useT } from '@hooks';

export const usePlanOptionLocalizationHelper = () => {
	const { T } = useT();
	const localizator = {
		weekTrialOptionLocalizations: {
			prompt: T('tariff_most_popular'),
			perDayText: T('tariff_per_day'),
			planTitle: T('tariff_trial_one_week'),
			perIntervalText: T('tariff_per_week'),
		},
		weekOptionLocalizations: {
			prompt: T('tariff_most_popular'),
			perDayText: T('tariff_per_day'),
			planTitle: T('tariff_one_week'),
			perIntervalText: T('tariff_per_week'),
		},
		monthOptionLocalizations: {
			prompt: T('tariff_most_popular'),
			perDayText: T('tariff_per_day'),
			planTitle: T('tariff_one_month'),
			perIntervalText: T('tariff_monthly'),
		},
		threeMonthOptionLocalizations: {
			prompt: T('tariff_most_popular'),
			perDayText: T('tariff_per_day'),
			planTitle: T('tariff_three_month'),
			perIntervalText: T('tariff_quaterly'),
		},
		sixMonthOptionLocalizations: {
			prompt: T('tariff_most_popular'),
			perDayText: T('tariff_per_day'),
			planTitle: T('tariff_six_month'),
			perIntervalText: T('tariff_semiannually'),
			promocodeText: T('discount_activated'),
			unlockedPromocodeText: T('unlocked_with_promo'),
		},
		yearOptionLocalizations: {
			prompt: T('tariff_most_popular'),
			perDayText: T('tariff_per_day'),
			planTitle: T('tariff_one_year'),
			perIntervalText: T('tariff_yearly'),
		},
	};
	return localizator;
};

export const PlanOptionIntervalHelper = {
	weekDaysInterval: 7,
	monthDaysInterval: 30,
	threeMonthsDaysInterval: 90,
	sixMonthsDayInterval: 183,
	yearDayInterval: 365,
};
